var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoALockWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 690,
    viewBox: "0 0 540 690",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.361 247.289L78.4414 340.209V498.738L113.716 534.012V417.441H210.218V588.093H245.492V247.289H171.361ZM210.218 382.166H113.716V354.82L185.972 282.563H210.218V382.166Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M426.277 533.641L371.825 588.093H288.652V247.289H323.927V552.819H357.214L376.392 533.641H426.277Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M347.229 0H192.394C120.843 0 62.8633 57.9982 62.8633 129.53V185.319L98.1375 150.045V129.53C98.1375 77.566 140.411 35.2742 192.394 35.2742H347.229C399.212 35.2742 441.485 77.566 441.485 129.53V150.045L476.759 185.319V129.53C476.759 57.9982 418.78 0 347.229 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.264 185.653C363.834 185.653 369.175 187.866 373.114 191.804L498.196 316.886C502.134 320.824 504.346 326.166 504.346 331.735V508.643C504.346 514.213 502.134 519.554 498.196 523.492L373.114 648.575C369.175 652.513 363.834 654.725 358.264 654.725H181.356C175.787 654.725 170.445 652.513 166.507 648.575L41.4249 523.492C37.4867 519.554 35.2742 514.213 35.2742 508.643V331.735C35.2742 326.166 37.4867 320.824 41.4249 316.886L166.507 191.804C170.445 187.866 175.787 185.653 181.356 185.653H358.264ZM387.724 156.53C383.786 152.591 378.445 150.379 372.875 150.379H166.745C161.176 150.379 155.834 152.591 151.896 156.53L6.15076 302.275C2.21249 306.213 0 311.555 0 317.124V523.254C0 528.824 2.21249 534.165 6.15076 538.103L151.896 683.849C155.834 687.787 161.176 690 166.745 690H372.875C378.445 690 383.786 687.787 387.724 683.849L533.47 538.103C537.408 534.165 539.621 528.824 539.621 523.254V317.124C539.621 311.555 537.408 306.213 533.47 302.275L387.724 156.53Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoALockWhite);
export default __webpack_public_path__ + "static/media/Logo_ALock_White.efdaa1dfc485c9e08285264b6143a857.svg";
export { ForwardRef as ReactComponent };